import React, { MouseEventHandler } from 'react';
import { AccordionDetails, AccordionSummary } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import EditIcon from '@material-ui/icons/Edit';
import CheckIcon from '@material-ui/icons/Check';

import AddCircle from '@material-ui/icons/AddCircle';
import ActionButton from 'components/Buttons/ActionButton';
import { AccordionWrapper } from 'components/SahamAccordion/styled-components';

export interface SahamAccordionProps {
  onChange: (event: React.ChangeEvent<{}>, expanded: boolean) => void;
  expanded: boolean;
  title: any;
  children?: JSX.Element;
  editButtonTitle?: string | null;
  deleteButtonTitle?: string | null;
  addButtonTittle?: string | null;
  accordionDetailsClassName?: string;
  editButtonOnClick?: MouseEventHandler;
  deleteButtonOnClick?: MouseEventHandler;
  addButtonOnclick?: MouseEventHandler;
  readOnly?: boolean;
  switchTransactionButtonTitle?: string | null;
  switchTransactionButtonOnClick?: MouseEventHandler;
  EditTransactionButtonTitle?: string | null;
  EditTransactionButtonOnClick?: MouseEventHandler;
}

const SahamAccordion: React.FC<SahamAccordionProps> = (props): JSX.Element => {
  return (
    <AccordionWrapper
      expanded={props.expanded}
      onChange={props.onChange}
      elevation={0}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />} className="accordion">
        <div className="accordion-title">{props.title}</div>

        {!props.readOnly && (
          <div className="accordion-buttons">
            {props.editButtonTitle && props.editButtonOnClick && (
              <ActionButton
                title={props.editButtonTitle}
                lefticon={<EditIcon className="accordion-button-icon" />}
                onClick={props.editButtonOnClick}
              />
            )}
            {props.deleteButtonTitle && props.deleteButtonOnClick && (
              <ActionButton
                title={props.deleteButtonTitle}
                lefticon={
                  <HighlightOffIcon className="accordion-button-icon" />
                }
                onClick={props.deleteButtonOnClick}
              />
            )}
            {props.addButtonTittle && props.addButtonOnclick && (
              <ActionButton
                title={props.addButtonTittle}
                lefticon={<AddCircle className="accordion-button-icon" />}
                onClick={props.addButtonOnclick}
              />
            )}
          </div>
        )}
        {((props.switchTransactionButtonTitle &&
          !props.readOnly &&
          props.switchTransactionButtonOnClick) ||
          (props.EditTransactionButtonTitle &&
            !props.readOnly &&
            props.EditTransactionButtonOnClick)) && (
          <div className="accordion-buttons-el">
            {props.switchTransactionButtonTitle &&
              !props.readOnly &&
              props.switchTransactionButtonOnClick && (
                <ActionButton
                  title={props.switchTransactionButtonTitle}
                  lefticon={<CheckIcon className="accordion-button-icon" />}
                  onClick={props.switchTransactionButtonOnClick}
                />
              )}
            {props.EditTransactionButtonTitle &&
              !props.readOnly &&
              props.EditTransactionButtonOnClick && (
                <ActionButton
                  title={props.EditTransactionButtonTitle}
                  lefticon={<EditIcon className="accordion-button-icon" />}
                  onClick={props.EditTransactionButtonOnClick}
                />
              )}
          </div>
        )}
      </AccordionSummary>
      <AccordionDetails className={props.accordionDetailsClassName}>
        {props.children}
      </AccordionDetails>
    </AccordionWrapper>
  );
};

SahamAccordion.defaultProps = {
  readOnly: false,
};

export default SahamAccordion;
